// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-selector {
  background-color: #ffffff;
  border-radius: 8px;
}
.date-range-selector__start-custom-input {
  height: 38px;
  padding-left: 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.date-range-selector__end-custom-input {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 96% center;
  height: 38px;
  text-indent: 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.date-range-selector__end-custom-input__label {
  position: absolute;
  top: -20px;
}
.date-range-selector__end-custom-input__label strong {
  color: #777;
}
.date-range-selector__range {
  display: flex;
  border: none;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  height: 40px;
}
.date-range-selector__label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}

.react-datepicker__aria-live {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/common/date-range-selector/date-range-selector.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,kBAAA;AACJ;AACI;EACI,YAAA;EACA,kBAAA;EAEA,YAAA;EACA,kBAAA;EACA,eAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAII;EACI,wEAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHR;AAKQ;EACI,kBAAA;EACA,UAAA;AAHZ;AAKY;EACI,WAAA;AAHhB;AAQI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AANR;AASI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPR;;AAWA;EACI,aAAA;AARJ","sourcesContent":[".date-range-selector {\n    background-color: #ffffff;\n    border-radius: 8px;\n\n    &__start-custom-input {\n        height: 38px;\n        padding-left: 10px;\n\n        border: none;\n        border-radius: 8px;\n        cursor: pointer;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__end-custom-input {\n        background: url('../../assets/icons/calendar.svg') no-repeat 96% center;\n        height: 38px;\n        text-indent: 10px;\n        border: none;\n        border-radius: 8px;\n        cursor: pointer;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n\n        &__label {\n            position: absolute;\n            top: -20px;\n            \n            strong {\n                color: #777;\n            }\n        }\n    }\n\n    &__range {\n        display: flex;\n        border: none;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        height: 40px;\n    }\n\n    &__label {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n}\n\n.react-datepicker__aria-live {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
